import React from "react";

const DeleteAccountSuccess = ({ history }) => {
  return (
    <div className="delete-account-success-main">
      <h2 className="title delete">
        Account
        <br />
        Deleted
      </h2>
      <p className="desc delete-success">
        Your account was successfully deleted. If you want to use heylime again
        you will have to create a new account.
      </p>
      <button className="onboarding-button" onClick={() => history.push("/")}>
        Back to heylime.com
      </button>
    </div>
  );
};

export default DeleteAccountSuccess;
